import { once } from 'lodash';
import { createContext } from 'react';
import { UseApiTendersTypeFactory } from './hooks';
import { MappedTendersTypes } from './types';

export const createApiTendersCtx = once(<TVars, Type extends keyof MappedTendersTypes | void>() =>
  createContext<UseApiTendersTypeFactory<TVars, Type> | null>(null)
);
